import { HttpHeaders } from '@angular/common/http';
import { ElementRef, Renderer } from '@angular/core';
import { json } from '../../assets/data/routemee';
import * as html2canvas from 'html2canvas';
declare let jsPDF: any;
import 'jspdf-autotable';
import { isArray } from 'util';
import { DecimalPipe, PercentPipe } from '@angular/common';
import * as moment from 'moment-timezone';
import 'moment-timezone';
import { Date2Pipe } from '../pipes/date2.pipe';

export class Helper {
  public compania = json['compania'];
  urlServerPadron: string;
  public urlServer: string;
  public header: HttpHeaders;
  public productionEnv = json.prodEnv;
  public colorApp = String(json['tableColor']).replace('#', '');
  private logoPdf = './assets/img/logo-pdf.png';
  baseUrl =  (this.productionEnv ? json.url : json.dev_url);
  urlImg = `${this.baseUrl}/uploads/imgs/`;
  private offset = -4;
  public monthNames = [
  'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun',
  'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
  public fullMonthNames = [
  'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
  'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
  public dayNames = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
  private headerStyle = json.tableColor;
  daysWeek = ['domingo', 'lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado'];
  constructor () {
    this.urlServer = (this.productionEnv ? json.socket : json.dev_socket);
    this.urlServerPadron = json.padron;
  }
  getHeader(token: any): HttpHeaders {
    this.header = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${ token || ''}`,
      'compania': String(this.compania)
    });
    return this.header;
  }

  getHeaderFiles(token: any): HttpHeaders {
    this.header = new HttpHeaders({
      'Authorization': `Bearer ${ token || ''}`,
      'compania': String(this.compania)
    });
    return this.header;
  }

  getMoment(date?: string) {
    return moment(date).tz('America/Santo_Domingo');
  }

  getDate() {
    return new Date(
      new Date().getTime() + this.offset * 3600 * 1000
    ).toUTCString().replace( / GMT$/, '' );
  }

  setDate(fecha) {
    return new Date(
      new Date(fecha).getTime() + this.offset * 3600 * 1000
    ).toUTCString().replace( / GMT$/, '' );
  }

  domingo(fecha: Date): boolean {
    return (fecha.getDay() === 0);
  }

  sabado(fecha: Date): boolean {
    return (fecha.getDay() === 6);
  }

  finSemana(fecha: Date): boolean {
    return (fecha.getDay() === 0 || fecha.getDay() === 6);
  }

  moverPositionArr(arr, old_index, new_index) {
    if (new_index >= arr.length) {
        let k = new_index - arr.length + 1;
        while (k--) {
            arr.push(undefined);
        }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr; // for testing
  }

  exportarReportePdf(
    config: any,
    titulo: string,
    columns: Array<any>,
    rows: Array<any>,
    empleado: string,
    columnStyles?: any,
    orientation = 'p',
    downOpen = false): Promise<any> {
    return new Promise((resolve) => {
      // const doc: PDF = new jsPDF();
      const doc = new jsPDF(orientation, 'pt', 'letter');
      const image = new Image();
      image.src = this.logoPdf;
      console.log(image);

      const imgWidth = 70;
      const imgHeight = image.height * imgWidth / image.width;
      const x = 10;
      const y = 10;
      const monthNames = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun',
      'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'
      ];
      const d = new Date,
      dformat = [
        (d.getDate() < 10 ? '0' + d.getDate() : d.getDate()),
        (monthNames[d.getMonth()]),
        d.getFullYear()].join(' ') + ' - ' +
        [(d.getHours() > 12 ? d.getHours() - 12 < 10 ? '0' + (d.getHours() - 12) :
        d.getHours() - 12 : d.getHours() < 10 ? '0' + d.getHours() : d.getHours()),
        (d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes())].join(':') +
        (d.getHours()  >= 12 ? ' PM' : ' AM');

      // Table
      doc.autoTableSetDefaults({
        headerStyles: {fillColor: this.headerStyle}
      });
      doc.autoTable(columns, rows, {
        styles: {
          // fillColor: [100, 255, 255],
          overflow: 'linebreak',
          tableWidth: 'auto',
          columnWidth: 'auto',
          fontSize: 10,
          cellPadding: 2,
          font: 'arial'
        },

        columnStyles,
        margin: { top: 140, right: 0, left: 0 },
        addPageContent: () => {
          // Header
          doc.addImage(image, 'PNG', x, y, imgWidth, imgHeight);

          // Left text
          doc.setFont('arial');
          doc.setFontSize(14);
          doc.setFontStyle('bold');
          doc.text(config.nombre_compania, 95, 20);
          doc.setFontSize(10);
          doc.setFontStyle('normal');
          doc.text('Oficina Principal', 95, 30);
          doc.setFontStyle('normal');
          doc.text(`${config.direccion_compania || ''}`, 95, 40);
          doc.text(`Tel(s).: ${config.tel_compania || ''}`, 95, 50);
          doc.text(`Fax: ${config.fax_compania || ''}`, 95, 60);
          doc.text(`Email: ${config.email_compania || ''}`, 95, 70);
          doc.text(`Rnc: ${config.rnc_compania || ''}`, 95, 80);

          // Right text
          doc.setFontStyle('bold');
          doc.text(`Página   : ${doc.internal.getNumberOfPages()}`, 370, 20);
          doc.setFontStyle('normal');
          doc.text(`Impreso  : ${dformat}`, 370, 30);
          doc.text(`Usuario  : ${empleado}`, 370, 40);

          // Title header
          doc.setFontSize(14);
          doc.setFontStyle('bold');
          doc.text('Hoja de Resumen', 15, 110);
          doc.line(15, 112, doc.getTextWidth('Hoja de Resumen')  + doc.getTextWidth(titulo) / 2, 112);
          doc.line(15, 114, doc.getTextWidth('Hoja de Resumen')  + doc.getTextWidth(titulo) / 2, 114);
          doc.setFontSize(10);
          doc.text(titulo, 15, 126);

        }
      });

      if (downOpen) {
        doc.save(titulo.replace(/\s/g, '_') + '.pdf');
      } else {
        window.open(doc.output('bloburl'), '_blank');
      }
      resolve('OK');
    });
  }

  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  async exportarCartaPdf(titulo: string, document: ElementRef, pdf: any) {

    const img = await this.htmlCanvasPdf(document).then(res => res);
    pdf.addImage(img, 'PNG', 0, 0);
    window.open(pdf.output('bloburl'), '_blank');
    // pdf.save(titulo);
  }

  private htmlCanvasPdf(document: ElementRef, options: Html2Canvas.Html2CanvasOptions = {}): Promise<any> {
    return new Promise((res, reject) => {
      html2canvas(document.nativeElement, options)
      .then( (canvas) => {
        res(canvas.toDataURL('image/png', 1.0));
      }).catch(err => {
        reject(err);
      });
    });
  }

  exportarEstadoCuenta(
    config: any,
    titulo: string,
    columns: Array<any>,
    rows: Array<any>,
    empleado: string,
    document: ElementRef,
    render: Renderer): Promise<any> {
    return new Promise(async (resolve) => {
      // const doc: PDF = new jsPDF();
      const doc = new jsPDF({format: 'letter', unit: 'pt'});
      const image = new Image();
      image.src = this.logoPdf;
      const imgWidth = 70;
      const imgHeight = image.height * imgWidth / image.width;
      const x = 10;
      const y = 10;
      const monthNames = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun',
      'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'
      ];
      const d = new Date,
      dformat = [
        (d.getDate() < 10 ? '0' + d.getDate() : d.getDate()),
        (monthNames[d.getMonth()]),
        d.getFullYear()].join(' ') + ' - ' +
        [(d.getHours() > 12 ? d.getHours() - 12 < 10 ? '0' + (d.getHours() - 12) :
        d.getHours() - 12 : d.getHours() < 10 ? '0' + d.getHours() : d.getHours()),
        (d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes())].join(':') +
        (d.getHours()  >= 12 ? ' PM' : ' AM');
      const pageWidth = doc.internal.pageSize.getWidth();

      render.setElementStyle(document.nativeElement, 'width', `${pageWidth}pt`);

      const imgCanvas = await this.htmlCanvasPdf(document).then(res => res);

      // Header
      doc.addImage(image, 'PNG', x, y, imgWidth, imgHeight);

      // Left text
      // doc.setFont('arial');
      // doc.setFontSize(10);
      // doc.setFontStyle('bold');
      // doc.text('Oficina Principal', 95, 20);
      // doc.setFontStyle('normal');
      // doc.text(`${config.direccion}`, 95, 30);
      // doc.text(`Tel(s).:${config.tel}`, 95, 40);
      // doc.text('Fax:', 95, 50);
      // doc.text('Email:', 95, 60);
      // doc.text('Rnc:', 95, 70);
      // Left text
      doc.setFont('arial');
      doc.setFontSize(14);
      doc.setFontStyle('bold');
      doc.text(config.nombre_compania, 95, 20);
      doc.setFontSize(10);
      doc.setFontStyle('normal');
      doc.text('Oficina Principal', 95, 30);
      doc.setFontStyle('normal');
      doc.text(`${config.direccion_compania || ''}`, 95, 40);
      doc.text(`Tel(s).: ${config.tel_compania || ''}`, 95, 50);
      doc.text(`Fax: ${config.fax_compania || ''}`, 95, 60);
      doc.text(`Email: ${config.email_compania || ''}`, 95, 70);
      doc.text(`Rnc: ${config.rnc_compania || ''}`, 95, 80);





      // Right text
      doc.setFontStyle('bold');
      doc.text(`Página   : ${doc.internal.getNumberOfPages()}`, 370, 20);
      doc.setFontStyle('normal');
      doc.text(`Impreso  : ${dformat}`, 370, 30);
      doc.text(`Usuario  : ${empleado}`, 370, 40);

      // Title header
      doc.setFontSize(14);
      doc.setFontStyle('bold');
      doc.text('ESTADO DE CUENTA', 15, 110);
      doc.line(15, 112, doc.getTextWidth('ESTADO DE CUENTA')  + doc.getTextWidth(titulo) / 2, 112);
      doc.line(15, 114, doc.getTextWidth('ESTADO DE CUENTA')  + doc.getTextWidth(titulo) / 2, 114);
      doc.setFontSize(10);
      doc.text('Detallado por Cuotas', 15, 126);

      doc.addImage(imgCanvas, 'JPEG', 0, 130);

      // Table
      doc.autoTable(columns, rows, {
        styles: {
          // fillColor: [100, 255, 255],
          overflow: 'linebreak',
          tableWidth: 'auto',
          columnWidth: 'auto',
          fontSize: 10,
          cellPadding: 2,
          font: 'arial'
        },

        margin: { top: 440, right: 0, left: 0 }
      });

      // doc.save(titulo.replace(/\s/g, '_') + '.pdf');
      window.open(doc.output('bloburl'), '_blank');
      resolve('OK');
    });
  }

  // tslint:disable-next-line:member-ordering
  numeroALetra = (function() {

    function Unidades(num) {

        switch (num) {
            case 1: return 'un';
            case 2: return 'Dos';
            case 3: return 'Tres';
            case 4: return 'Cuatro';
            case 5: return 'Cinco';
            case 6: return 'Seis';
            case 7: return 'Siete';
            case 8: return 'Ocho';
            case 9: return 'Nueve';
        }

        return '';
    }// Unidades()

    function Decenas(num) {

        const decena = Math.floor(num / 10);
        const unidad = num - (decena * 10);

        switch (decena) {
            case 1:
                switch (unidad) {
                    case 0: return 'Diez';
                    case 1: return 'Once';
                    case 2: return 'Doce';
                    case 3: return 'Trece';
                    case 4: return 'Catorce';
                    case 5: return 'Quince';
                    default: return 'Dieci' + Unidades(unidad);
                }
            case 2:
                switch (unidad) {
                    case 0: return 'Veinte';
                    default: return 'Veinti' + Unidades(unidad);
                }
            case 3: return DecenasY('Treinta', unidad);
            case 4: return DecenasY('Cuarenta', unidad);
            case 5: return DecenasY('Cincuenta', unidad);
            case 6: return DecenasY('Sesenta', unidad);
            case 7: return DecenasY('Setenta', unidad);
            case 8: return DecenasY('Ochenta', unidad);
            case 9: return DecenasY('Noventa', unidad);
            case 0: return Unidades(unidad);
        }
    }// Unidades()

    function DecenasY(strSin, numUnidades) {
        if (numUnidades > 0) {
            return strSin + ' y ' + Unidades(numUnidades);
        }

        return strSin;
    }// DecenasY()

    function Centenas(num) {
        const centenas = Math.floor(num / 100);
        const decenas = num - (centenas * 100);

        switch (centenas) {
            case 1:
                if (decenas > 0) {
                    return 'Ciento ' + Decenas(decenas);
                }
                return 'Cien';
            case 2: return 'Doscientos ' + Decenas(decenas);
            case 3: return 'Trescientos ' + Decenas(decenas);
            case 4: return 'Cuatrocientos ' + Decenas(decenas);
            case 5: return 'Quinientos ' + Decenas(decenas);
            case 6: return 'Seiscientos ' + Decenas(decenas);
            case 7: return 'Setecientos ' + Decenas(decenas);
            case 8: return 'Ochocientos ' + Decenas(decenas);
            case 9: return 'Novecientos ' + Decenas(decenas);
        }

        return Decenas(decenas);
    }// Centenas()

    function Seccion(num, divisor, strSingular, strPlural) {
        const cientos = Math.floor(num / divisor);
        const resto = num - (cientos * divisor);

        let letras = '';

        if (cientos > 0) {
        if (cientos > 1) {
                letras = Centenas(cientos) + ' ' + strPlural;
            } else {
                letras = strSingular;
            }
        }

        if (resto > 0) {
            letras += '';
        }

        return letras;
    } // Seccion()

    function Miles(num) {
        const divisor = 1000;
        const cientos = Math.floor(num / divisor);
        const resto = num - (cientos * divisor);

        const strMiles = Seccion(num, divisor, 'Mil', 'Mil');
        const strCentenas = Centenas(resto);

        if (strMiles === '') {
            return strCentenas;
        }

        return strMiles + ' ' + strCentenas;
    }
    // Miles()

    function Millones(num) {
        const divisor = 1000000;
        const cientos = Math.floor(num / divisor);
        const resto = num - (cientos * divisor);

        const strMillones = Seccion(num, divisor, 'Un Millon de', 'Millones de');
        const strMiles = Miles(resto);

        if (strMillones === '') {
            return strMiles;
        }

        return strMillones + ' ' + strMiles;
    }
    // Millones()

    return function NumeroALetras(num, currency, isCurrency = true) {
        currency = currency || {};
        const data = {
            numero: num,
            enteros: Math.floor(num),
            centavos: (((Math.round(num * 100)) - (Math.floor(num) * 100))),
            letrasCentavos: '',
            letrasMonedaPlural: currency.plural || 'Pesos', // 'PESOS', 'Dólares', 'Bolívares', 'etcs'
            letrasMonedaSingular: currency.singular || 'Peso', // 'PESO', 'Dólar', 'Bolivar', 'etc'
            letrasMonedaCentavoPlural: currency.centPlural || 'Centavos',
            letrasMonedaCentavoSingular: currency.centSingular || 'Centavo'
        };

        if (data.centavos > 0) {
            data.letrasCentavos = 'con ' + (function () {
                    if (data.centavos === 1) {
                        return Millones(data.centavos) + ' ' + data.letrasMonedaCentavoSingular;
                    } else {
                        return Millones(data.centavos) + ' ' + data.letrasMonedaCentavoPlural;
                    }
                })();
        }

        if (isCurrency) {

          if (data.enteros === 0) {
              return 'Cero ' + data.letrasMonedaPlural + ' ' + data.letrasCentavos + ' 00/100';
          }

          if (data.enteros === 1) {
              return Millones(data.enteros) + ' ' + data.letrasMonedaSingular + ' ' + data.letrasCentavos;
          } else {
              return Millones(data.enteros) + ' ' + data.letrasMonedaPlural + ' ' + data.letrasCentavos;
          }
        } else {
          if (data.enteros === 1) {
            return Millones(data.enteros);
          } else {
            return Millones(data.enteros);
          }
        }
    };

  })();

  async exportarPagareNotarialPdf(titulo: string, document: ElementRef, pdf: any) {

    const img = await this.htmlCanvasPdf(document, { letterRendering: true }).then(res => res);
    pdf.addImage(img, 'PNG', 0, 0);
    window.open(pdf.output('bloburl'), '_blank');
    // pdf.save(titulo);
  }

  exportarRentabilidad(
    config: any,
    titulo: string,
    columns: Array<any>,
    rows: Array<any>,
    empleado: string,
    document: ElementRef,
    render: Renderer,
    columnStyles?: any,
    downOpen = true
    ): Promise<any> {
    return new Promise(async (resolve) => {
      // const doc: PDF = new jsPDF();
      const doc = new jsPDF({format: 'letter', orientation: "landscape", unit: 'pt'});
      const image = new Image();
      image.src = this.logoPdf;


      const imgWidth = 70;
      const imgHeight = image.height * imgWidth / image.width;
      const x = 10;
      const y = 10;
      const monthNames = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun',
      'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'
      ];
      const d = new Date,
      dformat = [
        (d.getDate() < 10 ? '0' + d.getDate() : d.getDate()),
        (monthNames[d.getMonth()]),
        d.getFullYear()].join(' ') + ' - ' +
        [(d.getHours() > 12 ? d.getHours() - 12 < 10 ? '0' + (d.getHours() - 12) :
        d.getHours() - 12 : d.getHours() < 10 ? '0' + d.getHours() : d.getHours()),
        (d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes())].join(':') +
        (d.getHours()  >= 12 ? ' PM' : ' AM');
      const pageWidth = doc.internal.pageSize.getWidth();

      render.setElementStyle(document.nativeElement, 'width', `${pageWidth/1.30}pt`);

      const imgCanvas = await this.htmlCanvasPdf(document).then(res => res);

      // Table
      doc.autoTableSetDefaults({
        headerStyles: {fillColor: this.headerStyle}
      });

      doc.autoTable(columns, rows, {
        styles: {
          // fillColor: [100, 255, 255],
          overflow: 'linebreak',
          tableWidth: 'auto',
          columnWidth: 'auto',
          fontSize: 10,
          cellPadding: 2,
          font: 'arial'
        },
        columnStyles,
        margin: { top: 320, right: 15, left: 15 },
        addPageContent: () => {
          // Header
          doc.addImage(image, 'PNG', x, y, imgWidth, imgHeight);

          // Left text
          doc.setFont('arial');
          doc.setFontSize(10);
          doc.setFontStyle('bold');
          doc.text('Oficina Principal', 95, 20);
          doc.setFontStyle('normal');
          doc.text(`${config.direccion}`, 95, 30);
          doc.text(`Tel(s).:${config.tel}`, 95, 40);
          doc.text('Fax:', 95, 50);
          doc.text('Email:', 95, 60);
          doc.text('Rnc:', 95, 70);

          // Right text
          doc.setFontStyle('bold');
          doc.text(`Página   : ${doc.internal.getNumberOfPages()}`, 370, 20);
          doc.setFontStyle('normal');
          doc.text(`Impreso  : ${dformat}`, 370, 30);
          doc.text(`Usuario  : ${empleado}`, 370, 40);

          // Title header
          doc.setFontSize(14);
          doc.setFontStyle('bold');
          doc.text('RENTABILIDAD DE RUTAS', 15, 110);
          doc.line(15, 112, doc.getTextWidth('RENTABILIDAD DE RUTAS')  + doc.getTextWidth(titulo) / 2, 112);
          doc.line(15, 114, doc.getTextWidth('RENTABILIDAD DE RUTAS')  + doc.getTextWidth(titulo) / 2, 114);
          doc.setFontSize(10);
          doc.text('', 15, 126);

          doc.addImage(imgCanvas, 'png', 15, 130);
        }
      });
      if (downOpen) {
        doc.save(titulo.replace(/\s/g, '_') + '.pdf');
      } else {
        window.open(doc.output('bloburl'), '_blank');
      }
      render.setElementStyle(document.nativeElement, 'width', `100%`);
      resolve('OK');
    });
  }

  tipoArchivo(filename) {
    const tipo = filename.split('.').pop();
    return String(tipo).toUpperCase();
  }

  tamanoArchivo(bytes) {
    const thresh = 1024;
    if (Math.abs(bytes) < thresh) {
        return bytes + ' B';
    }
    const units = ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    let u = -1;
    do {
        bytes /= thresh;
        ++ u;
    } while (Math.abs(bytes) >= thresh && u < units.length - 1);
    return bytes.toFixed(1) + ' ' + units[u];
  }

  imprimirCuadre(cuadre, fecha_apertura: string) {
    const dp = new Date2Pipe();
    const np = new DecimalPipe('en-US');
    const pp = new PercentPipe('en-US');
    const doc = new jsPDF('p', 'pt', 'letter');
    // BORDERS TOP
    doc.line(5, 5, 607, 5);
    doc.line(7, 7, 605, 7);
    // BORDERS RIGHT
    doc.line(607, 5, 607, 787);
    doc.line(605, 7, 605, 785);
    // BORDERS BOTTOM
    doc.line(5, 787, 607, 787);
    doc.line(7, 785, 605, 785);
    // BORDERS LEFT
    doc.line(5, 5, 5, 787);
    doc.line(7, 7, 7, 785);

    doc.setFontSize(14);
    doc.setFontStyle('bold');

    // HEADER
    doc.setDrawColor(0);
    doc.setFillColor(131, 218, 225);
    doc.rect(7, 7, 598, 25, 'FD');
    // TITULO
    const media = doc.getTextWidth(`HOJA DE CUADRE DEL DIA / ${cuadre.ruta}`) > 598 ? 14 : 598 - doc.getTextWidth(`HOJA DE CUADRE DEL DIA / ${cuadre.ruta}`);
    doc.text(
      doc.splitTextToSize(`HOJA DE CUADRE DEL DIA / ${cuadre.ruta}`, 600), media / 2, 25
    );

    doc.setFontSize(12);
    // FECHA
    doc.setDrawColor(0);
    doc.setFillColor(131, 218, 225);
    doc.rect(7, 40, 598, 25, 'FD');

    doc.setFillColor(242, 223, 210);
    doc.rect(7, 40, 90, 25, 'FD');

    // SEMANA
    doc.text(`Sem. ${cuadre.semana_cuadre}`, 10, 58);
    doc.text(
      `${fecha_apertura}`,
      (598 - doc.getTextWidth(`${fecha_apertura}`)) / 2, 58
    );

    // BODY
    const columns = [
      {title: "1", dataKey: "cl1"},
      {title: "2", dataKey: "cl2"},
      {title: "3", dataKey: "cl3"},
    ];

    const opt = {
      drawHeaderRow: () => false,
      drawCell: function (cell, data) {
        // Rowspan
        if (data.row.raw['cl2'] == 'TITULO') {
          const cell1 = data.row.cells['cl1'];
          doc.setFillColor(250, 208, 142);
          doc.rect(cell1.x, cell1.y, data.table.width, cell1.height, 'F');
          doc.text(
            cell1.raw.replace('=', ''),
            cell1.x + doc.getTextWidth(cell1.raw) / 3,
            cell1.y + (cell1.height / 1.4)
          );
          return false;
        } else if (data.row.raw['cl2'] !== 'TITULO' && !data.row.raw['cl3']) {
          const cell1 = data.row.cells['cl1'];
          const cell2 = data.row.cells['cl2'];
          const widthRect = data.table.width - cell1.width;
          doc.rect(cell2.x, cell2.y, widthRect, cell2.height, 'S');
          doc.autoTableText(
            String(cell1.raw),
            cell1.x + cell1.width - 4.5,
            cell1.y + cell1.height / 2,
            {
              halign: 'right',
              valign: 'middle',
            }
          );
          doc.autoTableText(
            String(cell2.raw),
            cell2.x + 5,
            cell2.y + cell2.height / 2,
            {
              halign: 'left',
              valign: 'middle'
            }
          );
          return false;
        } else if (!data.row.raw['cl2']) {
          data.row.cells['cl2'].styles.lineWidth = 0;
        }
      },
      startY: 90,
      margin: { left: 194 },
      styles: {
        fontSize: 8,
        cellPadding: 2,
        fontStyle: 'bold',
        textColor: 0,
      },
      tableWidth: 200,
      columnStyles: {
        cl1: {
          fillColor: 255,
          halign: 'right',
          columnWidth: 130
        },
        cl2: {
          fillColor: 255,
          lineColor: 0,
          lineWidth: 0.5
        },
        cl3: {
          fillColor: 255,
          lineColor: 0,
          lineWidth: 0.5
        },
      },
    };
    // EFECTIVO
    doc.setFillColor(150, 236, 137);
    doc.rect(194, 70, 200, 19, 'F');
    doc.text('EFECTIVO', ((200 - doc.getTextWidth('EFECTIVO')) / 2) + 194, 85);
    const gastos = cuadre.gastos.reduce((a ,b) => a + b.monto_gasto, 0);
    const salidas_efectivo = cuadre.salidas_efectivo.reduce((a ,b) => a + b.capital, 0);
    const efectivo = {
      "PRESTADO" : np.transform(cuadre.monto_prestado, '1.0-2'),
      "EFECTIVO" : np.transform(cuadre.monto_depositado, '1.0-2'),
      "GASTOS" : np.transform(gastos, '1.0-2'),
      "MONTO INICIAL" : np.transform(cuadre.monto_apertura, '1.0-2'),
      "GASTO CIERRE" : np.transform(cuadre.prestamos_nuevos + cuadre.renovaciones, '1.0-2'),
      "TOTAL COBRADO" : np.transform(cuadre.monto_cobrado + cuadre.mora, '1.0-2'),
      "SALIDA EFECTIVO" : np.transform(salidas_efectivo, '1.0-2'),
    };
    if (cuadre.mora == 0) {
      delete efectivo["MORA COBRADA"];
    }
    if (cuadre.cobros_extraordinarios == 0) {
      delete efectivo["COBROS EXTRAORDINARIOS"];
    }
    if (cuadre.mora_extraordinaria == 0) {
      delete efectivo["MORA EXTRAORDINARIA"];
    }
    if (salidas_efectivo == 0) {
      delete efectivo["SALIDA EFECTIVO"];
    }

    let limitExtra = 0;
    for(const cobroExtra of cuadre.cobros_extraordinarios_v2) {
      Object.defineProperty(efectivo,'COBROS EXTRAORDINARIOS',{value: 'TITULO',enumerable: true});
      Object.defineProperty(
        efectivo,
        cobroExtra.descripcion,
        {
          value: np.transform(cobroExtra.monto, '1.0-2'),
          enumerable: true
        }
      );
      limitExtra ++;
      if (limitExtra == 2) {
        Object.defineProperty(
          efectivo,
          '+ OTROS',
          {
            value: np.transform(
              cuadre.cobros_extraordinarios_v2
              .splice(limitExtra)
              .reduce((a, b) => a + b.monto, 0),
              '1.0-2'
            ),
            enumerable: true
          }
        );
        break;
      }
    }

    limitExtra = 0;
    for(const moraExtra of cuadre.mora_extraordinaria_v2) {
      Object.defineProperty(efectivo,'MORA EXTRAORDINARIA',{value: 'TITULO',enumerable: true});
      Object.defineProperty(
        efectivo,
        efectivo.hasOwnProperty(moraExtra.descripcion) ? moraExtra.descripcion + ' ' : moraExtra.descripcion,
        {
          value: np.transform(moraExtra.monto, '1.0-2'),
          enumerable: true
        }
      );
      limitExtra ++;
      if (limitExtra == 2) {
        Object.defineProperty(
          efectivo,
          '+ OTROS ',
          {
            value: np.transform(
              cuadre.mora_extraordinaria_v2
              .splice(limitExtra)
              .reduce((a, b) => a + b.monto, 0),
              '1.0-2'
            ),
            enumerable: true
          }
        );
        break;
      }
    }

    limitExtra = 0;
    for(const row of cuadre.prestamos_extraordinarios_v2) {
      Object.defineProperty(efectivo,'PRESTAMOS EXTRAORDINARIOS',{value: 'TITULO',enumerable: true});
      Object.defineProperty(
        efectivo,
        row.descripcion,
        {
          value: np.transform(row.monto, '1.0-2'),
          enumerable: true
        }
      );
      limitExtra ++;
      if (limitExtra == 2) {
        Object.defineProperty(
          efectivo,
          ' + OTROS',
          {
            value: np.transform(
              cuadre.prestamos_extraordinarios_v2
              .splice(limitExtra)
              .reduce((a, b) => a + b.monto, 0),
              '1.0-2'
            ),
            enumerable: true
          }
        );
        break;
      }
    }

    let rows = Object.keys(efectivo).map((key) => {
      if (isArray(efectivo[key])) {
        return {
          'cl1': key + '=',
          'cl2': efectivo[key][0],
          'cl3': efectivo[key][1],
        };
      } else {
        return { 'cl1': key + '=', 'cl2': efectivo[key] };
      }
    });

    doc.autoTable(columns, rows, opt);
    doc.setDrawColor(0);
    doc.setLineWidth(2);
    doc.rect(194, 340, 200, 50, 'S');
    doc.setFontSize(16);
    if (cuadre.diferencia < 0) {
      doc.setTextColor(171, 50, 50);
    } else if (cuadre.diferencia > 0) {
      doc.setTextColor(73, 125, 64);
    } else {
      doc.setTextColor(0, 206, 209);
    }
    doc.text(cuadre.diferencia !== 0 ? 'Con diferencia' : 'OK', ((200 - doc.getTextWidth(cuadre.diferencia !== 0 ? 'Con diferencia' : 'OK')) / 2) + 194, 370);
    doc.setFontSize(12);
    doc.setTextColor(0);

    // ESTADISTICA DE COBRO
    doc.setFillColor(234, 160, 67);
    doc.rect(404, 70, 200, 19, 'F');
    doc.text('ESTADISTICA DE COBRO', ((200 - doc.getTextWidth('ESTADISTICA DE COBRO')) / 2) + 404, 85);
    const estadisticaCobro = {
      "CLIENTES" : [cuadre.clientes_anterior, cuadre.clientes_cobrado],
      "%CLIENTES / COBRO" : [pp.transform(cuadre.clientes_cobrado_porciento) , pp.transform(cuadre.cobro_min)],
      "%PRESTADO / COBRADO" : pp.transform(cuadre.prestado_cobrado),
      "HR. PRIMER COBRO" : dp.transform(moment(cuadre.hr_primer_cobro).format(), 'h:mm:ss a'),
      "HR. ULTIMO COBRO" : dp.transform(moment(cuadre.hr_ultimo_cobro).format(), 'h:mm:ss a'),
      "HR. CIERRE DIA" : dp.transform(moment(cuadre.hr_final_cobro).format(), 'h:mm:ss a'),
      "TTC / DIF. (HCD-HULT)" : [cuadre.tiempo_total_cobro, cuadre.dif_cierre_ultimo_cobro],
      "CCC12M" : [cuadre.clientes_cobrados_12, pp.transform(cuadre.clientes_cobrados_12_porciento)],
      "VELOC.C HASTA 12 PM" : np.transform(cuadre.velocidad_cobro_12, '1.0-2')+" CTES/H",
      "VELOCIDAD COBRO" : np.transform(cuadre.velocidad_cobro, '1.0-2')+" CTES/H"
    };
    rows = Object.keys(estadisticaCobro).map((key) => {
      if (isArray(estadisticaCobro[key])) {
        return {
          'cl1': key + '=',
          'cl2': estadisticaCobro[key][0],
          'cl3': estadisticaCobro[key][1],
        };
      } else {
        return { 'cl1': key + '=', 'cl2': estadisticaCobro[key] };
      }
    });

    opt.startY = 90;
    opt.margin.left = 404;
    opt.columnStyles.cl1.columnWidth = 100;
    doc.autoTable(columns, rows, opt);

    // DETALLE DE CUOTA
    doc.setFillColor(177, 246, 241);
    doc.rect(7.5, 70, 174.5, 19, 'F');
    doc.text('DETALLE DE CUOTA', ((174 - doc.getTextWidth('DETALLE DE CUOTA')) / 2), 85);

    const detalleCuota = {
      "CUOTA ANT" : np.transform(cuadre.cuota_anterior, '1.0-2'),
      "CUOTA ACT" : np.transform(cuadre.cuota_actual, '1.0-2'),
      "V.CUOTA" : np.transform(cuadre.cuota_actual - cuadre.cuota_anterior, '1.0-2'),
      "ANTICIPOS" : np.transform(cuadre.anticipos, '1.0-2'),
      "V.ATRASOS" : np.transform(cuadre.variacion_atrasos, '1.0-2'),
    };
    rows = Object.keys(detalleCuota).map((key) => {
      if (isArray(detalleCuota[key])) {
        return {
          'cl1': key + '=',
          'cl2': detalleCuota[key][0],
          'cl3': detalleCuota[key][1],
        };
      } else {
        return { 'cl1': key + '=', 'cl2': detalleCuota[key] };
      }
    });

    opt.margin.left = 7;
    opt.tableWidth = 175;
    opt.columnStyles.cl1.columnWidth = 70;
    doc.autoTable(columns, rows, opt);

    // COBRO META
    const cobroMeta = {
      "C.META" : '$'+np.transform(cuadre.cuota_meta, '1.0-2'),
      "C.NEC." : '$'+np.transform(cuadre.cuota_necesaria, '1.0-2'),
      "CTE.IN." : [np.transform(cuadre.clientes_in_nuevos, '1.0-2'), np.transform(cuadre.clientes_in_renovacion, '1.0-2')],
      "C.IN." : ['$'+np.transform(cuadre.cuota_in_nuevos, '1.0-2'), '$'+np.transform(cuadre.cuota_in_renovacion, '1.0-2')],
      "CTE OUT" : np.transform(cuadre.clientes_out, '1.0-2'),
    };
    rows = Object.keys(cobroMeta).map((key) => {
      if (isArray(cobroMeta[key])) {
        return {
          'cl1': key + '=',
          'cl2': cobroMeta[key][0],
          'cl3': cobroMeta[key][1],
        };
      } else {
        return { 'cl1': key + '=', 'cl2': cobroMeta[key] };
      }
    });

    opt.startY = 190;
    opt.margin.left = 8;
    opt.tableWidth = 175;
    opt.columnStyles.cl1.halign = 'right';
    opt.columnStyles.cl1.columnWidth = 55;
    doc.autoTable(columns, rows, opt);

    const cobroMeta2 = {
      "C.OUT." : '$'+np.transform(cuadre.cuota_out, '1.0-2'),
      "C.IN-OUT." : '$'+np.transform(cuadre.cuota_in_out, '1.0-2'),
      "N.C.N." : '$'+np.transform(cuadre.ncn, '1.0-2'),
      "CTES.A.P." : "0",
      "C.A.P." : "$0.00",
    };
    rows = Object.keys(cobroMeta2).map((key) => {
      if (isArray(cobroMeta2[key])) {
        return {
          'cl1': key + '=',
          'cl2': cobroMeta2[key][0],
          'cl3': cobroMeta2[key][1],
        };
      } else {
        return { 'cl1': key + '=', 'cl2': cobroMeta2[key] };
      }
    });
    opt.startY = 256.5;
    opt.margin.left = 8;
    doc.autoTable(columns, rows, opt);

    // OBJETIVOS DIARIOS (LAS 3C'S)
    doc.setFillColor(234, 160, 67);
    doc.rect(404, 250, 200, 19, 'F');
    doc.text(`OBJETIVOS DIARIOS (LAS 3C'S)`, ((200 - doc.getTextWidth(`OBJETIVOS DIARIOS (LAS 3C'S)`)) / 2) + 404, 265);

    const objetivosDiarios = {
      "1) 90% COBRO MIN." : [pp.transform(cuadre.cobro_min), pp.transform(cuadre.cobro_min)],
      "2) 2 CLIENTES NUEVOS" : [cuadre.clientes_nuevos_min, pp.transform(cuadre.clientes_nuevos_min / 2)],
      "3) AUMENTO CUOTA" : [pp.transform(cuadre.aumento_cuota_min), pp.transform(cuadre.aumento_cuota_min)],
      "4) 1 A.P. MIN." : ['0', '0%'],
      "TOTAL" : ['', pp.transform((cuadre.cobro_min + (cuadre.clientes_nuevos_min / 2) + cuadre.aumento_cuota_min) / 3)],
    };
    rows = Object.keys(objetivosDiarios).map((key) => {
      if (isArray(objetivosDiarios[key])) {
        return {
          'cl1': key,
          'cl2': objetivosDiarios[key][0],
          'cl3': objetivosDiarios[key][1],
        };
      } else {
        return { 'cl1': key, 'cl2': objetivosDiarios[key] };
      }
    });

    opt.startY = 268;
    opt.margin.left = 404;
    opt.tableWidth = 200;
    opt.columnStyles.cl1.halign = 'left';
    opt.columnStyles.cl1.columnWidth = 110;
    doc.autoTable(columns, rows, opt);

    // DIREFENCIA
    const $saliente = cuadre.monto_prestado + gastos + salidas_efectivo + cuadre.prestamos_extraordinarios;
    const $entrante = cuadre.monto_cobrado + cuadre.monto_apertura + cuadre.prestamos_nuevos + cuadre.renovaciones + cuadre.mora + cuadre.mora_extraordinaria + cuadre.cobros_extraordinarios;
    const $diferencia = cuadre.diferencia;
    doc.autoTable(
      [{title: '', dataKey: 'cl1'}, {title: '', dataKey: 'cl2'}],
      [
        {
          'cl1': 'DINERO SALIENTE',
          'cl2': 'RD$' + np.transform($saliente, '1.0-2')
        },
        {
          'cl1': 'DINERO ENTRANTE',
          'cl2': 'RD$' + np.transform($entrante, '1.0-2')
        },
        {
          'cl1': 'DIFERENCIA',
          'cl2': 'RD$' + np.transform($diferencia, '1.0-2')
        }
      ],
      {
        drawHeaderRow: () => false,
        drawRow: function (row) {
          const rawKey = row.raw.cl1;
          switch(rawKey) {
            case 'DINERO ENTRANTE':
              row.cells.cl1.styles.fillColor = [73, 125, 64];
              row.cells.cl2.styles.fillColor = [73, 125, 64];
            break;
            case 'DINERO SALIENTE':
              row.cells.cl1.styles.fillColor = [171, 50, 50];
              row.cells.cl2.styles.fillColor = [171, 50, 50];
              break;
            default:
            row.cells.cl1.styles.fillColor = 0;
            row.cells.cl2.styles.fillColor = 0;
            // if (parseFloat(row.cells.cl2.raw.replace('RD$', '')) >= 0) {
            //   row.cells.cl2.styles.textColor = 73;
            // } else {
            //   row.cells.cl2.styles.textColor = 171;
            // }
          }
        },
        startY: 400,
        margin: { left: 150 },
        styles: {
          fontSize: 12,
          fontStyle: 'bold',
          textColor: 255,
        },
        tableWidth: 300,
        columnStyles: {
          cl1: {
            lineWidth: 0,
            halign: 'left',
            columnWidth: 150
          },
          cl2: {
            lineWidth: 0
          }
        },
      }
    );

    // OBSERVACIONES
    doc.text('OBSERVACIONES:', 10, 550);
    doc.setDrawColor(0);
    doc.setLineWidth(1.5);
    doc.rect(10, 555, 340, 220);
    doc.setFontSize(10);
    let OBSERVACIONES = '';
    if (cuadre.gastos.length) {
      OBSERVACIONES += '\nGASTOS: ' + cuadre.gastos.map(value => value.descripcion + ` (RD$${value.monto_gasto})`).join(', ');
    }
    if (cuadre.salidas_efectivo.length) {
      OBSERVACIONES += '\nSALIDA DE EFECTIVO: ' + cuadre.salidas_efectivo.map(value => value.nota + ` (RD$${value.capital})`).join(', ');
    }
    if (cuadre.detalle_cierre) {
      OBSERVACIONES += '\nRAZON DIFERENCIA: ' + cuadre.detalle_cierre;
    }
    doc.text(doc.splitTextToSize(OBSERVACIONES, 330), 15, 565);

    doc.setFontSize(10);

    const y = 575 - (Math.ceil(doc.getTextWidth(cuadre.empleado + ' / ' + cuadre.acompanante) / 240 ) * 10);
    doc.text(doc.splitTextToSize(cuadre.empleado + ' / ' + cuadre.acompanante, 240), 360, y);
    doc.text(cuadre.cerrado_por, 360, 655);
    // FOOTER
    doc.setFontSize(12);
    doc.setDrawColor(0);
    doc.line(360, 580, 590, 580);
    doc.text('Representantes', ((230 - doc.getTextWidth('Representantes')) / 2) + 360, 595);

    doc.line(360, 660, 590, 660);
    doc.text('Cuadrado por', ((230 - doc.getTextWidth('Cuadrado por')) / 2) + 360, 675);

    doc.line(360, 730, 590, 730);
    doc.text('Revisado por', ((230 - doc.getTextWidth('Revisado por')) / 2) + 360, 745);
    window.open(doc.output('bloburl'), '_blank');
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/helpers/helper.ts